module.exports = __webpack_public_path__ + "img/delete-icon.2ec98685.svg";